import styled from 'styled-components'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function Page6Pc(prop) {
  const { banner } = prop
  return (
    <MainContainer>
      {banner && (
        <>
          {banner.baTitle && <Text1>{banner.baTitle}</Text1>}
          {banner.baContents && (
            <Text2
              dangerouslySetInnerHTML={{ __html: banner.baContents }}
            ></Text2>
          )}
          {banner.baFileDto?.filePath && (
            <Img
              src={
                process.env.REACT_APP_BASE_RESOURCES_API +
                banner.baFileDto.filePath
              }
            />
          )}
          {banner.baSubFileDto?.filePath && (
            <ContentImg
              src={
                process.env.REACT_APP_BASE_RESOURCES_API +
                banner.baSubFileDto.filePath
              }
            />
          )}
        </>
      )}
    </MainContainer>
  )
}

export default Page6Pc

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 82px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 102px;
  background: #f7f7f7;
`
const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: 300;
  font-size: 25px;
  color: #000;
  letter-spacing: -1px;
  margin-top: 57.8px;
  text-align: center;
`
const Text2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 41.7px;
  color: #000;
  letter-spacing: -0.5px;
  margin-top: 0px;
  text-align: center;
`
const Img = styled.img`
  width: 100%;
  height: 464px;
  object-fit: cover;
  margin-top: 30px;
`
const ContentImg = styled.img`
  width: 60vw;
  margin-top: 64px;
  margin-bottom: 100px;
`
